import {FieldInput} from './template';

export default FieldInput;
